import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import qs from 'query-string';

import { queryStringifyOptions } from 'utils/constants';

import InProgressSection from '../admin-servicers/InProgressSection';
import CompletedSection from '../admin-servicers/CompletedSection';
import { DashboardTemplate } from 'containers/dashboard/common-components';
import ProviderActionsToTake from './ProviderActionsToTake';

const ProviderDashboard = () => {
    const navigate = useNavigate();

    const handleInfoCardFilter = useCallback(
        (payload, listType) => () => {
            navigate(`/${listType}?${qs.stringify(payload, queryStringifyOptions)}`);
        },
        [navigate]
    );

    return (
        <DashboardTemplate>
            <ProviderActionsToTake onListFilter={handleInfoCardFilter} />
            <InProgressSection onListFilter={handleInfoCardFilter} userIsProvider />
            <CompletedSection onListFilter={handleInfoCardFilter} userIsProvider />
        </DashboardTemplate>
    );
};

export default ProviderDashboard;
